module.exports = __webpack_public_path__ + "static/media/news-cover-mobile.248927b3.jpg";